export const getStatusColor = (status) => {
  const statusMap = {
    PENDING: { color: 'default', label: 'Pending' },
    NOT_STARTED: { color: 'default', label: 'Not Started' },
    IN_PROGRESS: { color: 'warning', label: 'In Progress' },
    COMPLETED: { color: 'success', label: 'Completed' },
    SUBMITTED: { color: 'info', label: 'Submitted' },
    UNDER_REVIEW: { color: 'secondary', label: 'Under Review' },
    REJECTED: { color: 'error', label: 'Rejected' },
    // BGV-specific statuses
    FAILED: { color: 'error', label: 'Failed' },
    CLEAR: { color: 'success', label: 'Clear' },
    DISCREPANCY: { color: 'error', label: 'Discrepancy' },
    // Offer-specific statuses
    SENT: { color: 'info', label: 'Sent' },
    ACCEPTED: { color: 'success', label: 'Accepted' },
    NEGOTIATING: { color: 'warning', label: 'Negotiating' },
    EXPIRED: { color: 'default', label: 'Expired' },
  };
  return statusMap[status] || { color: 'default', label: status };
};